module.exports = __webpack_public_path__ + "img/bootstrap.2def757e.png";